/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-09T11:53:38-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-07T13:19:45-07:00
*/



import React, { Component } from 'react';
import Container from '../../blocks/Container';
import ResultList from '../../blocks/ResultList';
import BlankSlate from '../../blocks/BlankSlate';
import userItem from '../../common/userItemFactory';
import Button from '../../blocks/Button';

import _ from 'lodash';


class FavoritedMeList extends Component {

  constructor(props) {
    super(props);
    this.favList = this.favList.bind(this);
  }

  favList(fav) {

    let UserItem = userItem('simple')
    // loop through each mail item.
    if(!_.isEmpty(fav)) {
      var FavList = Object.keys(fav).map((key) => {
        let acct = fav[key].other_account.data;
        let profile = acct.profile.data
        return <UserItem key={key} favKey={key} title={acct.username} city={profile.city}
          age={profile.age}
          region={profile.region} country={profile.country} description={profile.description}
          avatar={profile.avatar.data.urls.thumbs} isFavorite={acct.is_favorite}
          toggle={this.props.toggle} />;
      })
      return (
        <div>
          {FavList}
          {this.props.moreExists &&
              <Button fit variant="link" onClick={() => {this.props.loadMore(this.props.tripId)}}>Load More</Button>
          }
        </div>
      );
    } else {
      return (
        <BlankSlate bordered title={this.props.noResultsTitle} msg={this.props.noResultsMsg} />
      );
    }
  }

  render() {
    let favorites = this.props.favorites;
    ////console.log("props: ", this.props.favorites);
    return (
      this.favList(favorites)
    );
  }
}



export default FavoritedMeList;



// WEBPACK FOOTER //
// ./src/components/pages/Trips/TripUsersList.jsx